export const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
} as const;

export const TIMELINE_ITEM_COLORS = {
  MEDIUM_GRAY: "#BBBBBB",
  PURPLE: "rgba(102, 0, 192, 0.4)",
  RED: "#FF0000",
  BLUE: "rgba(59, 130, 246, 0.6)",
  GREEN: "rgba(34, 197, 94, 0.6)",
  ORANGE: "rgba(249, 115, 22, 0.6)",
  TEAL: "rgba(20, 184, 166, 0.7)",
};

export const ZONE_BASED_PREDICTIONS_GROUP = "Zone Based Predictions" as const;

export const MIN_TIMELINE_RANGE = {
  beforeMinutes: 30,
  afterMinutes: 30,
};

export const MAX_TIMELINE_RANGE = {
  beforeMinutes: 120,
  afterMinutes: 120,
};

export type TimelineItemView =
  | "timeline-item-track"
  | "timeline-item-event-range"
  | "timeline-item-event"
  | "timeline-item-system-time"
  | "timeline-item-system-time-circle";

export const TIMELINE_ITEM_VIEW = {
  TRACK: "timeline-item-track" as const,
  EVENT_RANGE: "timeline-item-event-range" as const,
  EVENT: "timeline-item-event" as const,
  SYSTEM_TIME: "timeline-item-system-time" as const,
  SYSTEM_TIME_CIRCLE: "timeline-item-system-time-circle" as const,
};
